import { useSelector } from 'react-redux';
import { makeCaptionsEnabledForVideoByIdSelector } from 'redux/modules/embed/selectors';
import { makeVideoSelector } from 'redux/modules/entities';
import { BaseTranscriptionConfig, VideoToEdit } from './types';

interface UseEditVideoTranscriptConfig {
  video?: VideoToEdit;
}

interface UseEditVideoTranscript {
  initialTranscriptConfig: BaseTranscriptionConfig;
  showTranscriptSection: boolean;
}

const useEditVideoTranscript = (
  config: UseEditVideoTranscriptConfig,
): UseEditVideoTranscript => {
  const { video } = config;

  const videoServerId = video?.serverId;
  const transcriptionEnabled = useSelector(
    makeCaptionsEnabledForVideoByIdSelector(videoServerId),
  );
  const videoUpload = useSelector(makeVideoSelector(videoServerId));

  const transcriptionLanguage = videoUpload?.language;
  const showTranscriptSection = video?.assetType === 'video';

  return {
    initialTranscriptConfig: {
      transcriptionEnabled,
      transcriptionLanguage,
    },
    showTranscriptSection,
  };
};

export default useEditVideoTranscript;
